import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { persistReducer } from 'redux-persist'
import search from './search'
import pushRoutePersisted from './pushRoutePersisted'
import drawer from './drawer'
import contentScroll from './contentScroll'
import storage from 'redux-persist/lib/storage'
import { device } from '../utils'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import snackbar from './snackbar'
import searchCid from './searchCid'
import users from './user'

export default history => {
  const router = connectRouter(history)

  const persistRouterOnlyIos = () => {
    if (device.isIosStandaloneMode()) {
      return persistReducer(
        {
          key: 'INFORMED_ROUTER',
          storage,
          stateReconciler: hardSet
        },
        router
      )
    }
    return router
  }

  return combineReducers({
    drawer,
    snackbar,
    search: persistReducer(
      {
        key: 'INFORMED_SEARCH_SAFE',
        storage,
        stateReconciler: hardSet
      },
      search
    ),
    searchCid,
    users,
    contentScroll: persistReducer(
      {
        key: 'INFORMED_CONTENT_SCROLL',
        storage,
        stateReconciler: hardSet
      },
      contentScroll
    ),
    router: persistRouterOnlyIos(),
    pushRouterPersisted: pushRoutePersisted(history)
  })
}
